import * as React from "react";

import {classNames} from "@reactivated";

const styles = {
    form: "space-y-[15px]",
    fieldset: "space-y-[15px] flex flex-col",
    readOnly: "form-read-only",
} as const;

export {Label} from "@client/components/Label";

export type {FieldSchema} from "./fields";
export {
    DecimalInput,
    QuickSelect,
    SelectNumber,
    SelectText,
    Switch,
    Checkbox,
    TextInput,
} from "./widgets";

export class Form extends React.Component<{
    readOnly?: boolean;
    children: React.ReactNode;
}> {
    handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
        event.preventDefault();
    };
    render() {
        return (
            <form
                noValidate
                onSubmit={this.handleSubmit}
                className={classNames(
                    styles.form,
                    this.props.readOnly === true && styles.readOnly,
                )}
            >
                {this.props.children}
            </form>
        );
    }
}
